module.exports = __webpack_public_path__ + "static/media/tasin.ed3c02b4.png";